import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Card, CircularProgress, Container, Grid, IconButton, Typography } from "@mui/material";
import { PlayArrowRounded } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { fatafatDollarActions } from '../../store/reducer/fatafat-dollar';

const FatafatDollarGameList = ({ isFatafatDollarLoading, fatafatDollarGameTypesData }: any) => {
    const { gameId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [gameTypes, setGameTypes] = useState<any>([])
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(fatafatDollarActions.fatafatDollarGameTypesReq(data))
    }, [])

    useEffect(() => {
        console.log('🔍 Fatafat Dollar Game Types Debug:');
        console.log('fatafatDollarGameTypesData:', fatafatDollarGameTypesData);
        console.log('Full data JSON:', JSON.stringify(fatafatDollarGameTypesData, null, 2));
        
        if (fatafatDollarGameTypesData && fatafatDollarGameTypesData.game_types) {
            const gameTypesArray = Array.isArray(fatafatDollarGameTypesData.game_types) 
                ? [...fatafatDollarGameTypesData.game_types] // Create a copy
                : [];
            console.log('✅ Found', gameTypesArray.length, 'game types');
            console.log('Game types array:', gameTypesArray);
            
            // Log each game type individually
            gameTypesArray.forEach((gt: any, idx: number) => {
                console.log(`Game Type ${idx + 1}: ID=${gt.id}, Name="${gt.name}", Label="${gt.label}"`);
            });
            
            // Ensure all 15 game types are present (debug)
            if (gameTypesArray.length < 15) {
                console.warn('⚠️ Only', gameTypesArray.length, 'game types found, expected 15');
                console.log('All IDs present:', gameTypesArray.map((gt: any) => gt.id).sort((a: number, b: number) => a - b));
            } else {
                console.log('✅ All 15 game types received!');
            }
            
            // Sort by id to ensure proper order (using copy, not original)
            const sortedGameTypes = gameTypesArray.sort((a: any, b: any) => (a.id || 0) - (b.id || 0));
            console.log('Sorted game types count:', sortedGameTypes.length);
            setGameTypes(sortedGameTypes);
        } else {
            console.log('❌ No game types data available');
            setGameTypes([]);
        }
    }, [fatafatDollarGameTypesData, isFatafatDollarLoading])

    const handleCardClick = (event: any, item: any) => {
        navigate(`/fatafat-dollar/place-bid/${gameId}/${item.id}/${item.session}`)
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    // Game type icons/colors
    const gameTypeColors: any = {
        'Single Digit': '#FF6B6B',
        'Jodi Digit': '#4ECDC4',
        'Single Pana': '#FFD93D',
        'Double Pana': '#6BCB77',
        'Triple Pana': '#4D96FF',
        'SP Motor': '#FF8FB1',
        'DP Motor': '#A1EEBD',
        'Jackpot': '#F875AA',
        'Series SP': '#FF6347',
        'Series DP': '#20B2AA',
        'Series SP DP TP': '#9370DB',
        'Block': '#FF4500',
        'All SP DP TP': '#32CD32',
        'Panna': '#FF8C00',
        'SP DP Motor': '#FFA500'
    };

    return (
        <div>
            <CustomAppBar title={'Select Game Type'} isBack={true} />
            {isFatafatDollarLoading ? 
                <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> 
                    <CircularProgress /> 
                </div> :
                <Container sx={{ 
                    paddingLeft: '0px !important', 
                    paddingRight: '0px !important', 
                    marginTop: '70px !important', 
                    paddingBottom: '50px',
                    minHeight: 'calc(100vh - 70px)',
                    overflow: 'auto'
                }}>
                    <Box sx={{ padding: '10px', marginBottom: '10px', textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '1.1rem', fontWeight: '600', color: '#666' }}>
                            Total Game Types: {gameTypes.length}
                        </Typography>
                    </Box>
                    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', padding: '5px' }}>
                        {(gameTypes.length) ? gameTypes.map((item: any, index: number) => {
                            // Debug log for each game type being rendered
                            console.log(`🔄 Rendering Game Type ${index + 1}/${gameTypes.length}: ID=${item.id}, Name="${item.name}"`);
                            return (
                            <Grid item xs={6} lg={3} md={4} sm={4} key={`game-type-${item.id}-${index}`}>
                                <Card variant="outlined"
                                    onClick={(event: any) => handleCardClick(event, item)}
                                    sx={{
                                        borderRadius: '22px',
                                        boxShadow: '0px 0px 2px #adadad27',
                                        border: '0px solid transparent',
                                        padding: '15px',
                                        backgroundColor: gameTypeColors[item.name] || '#f7ae2b',
                                        cursor: 'pointer',
                                        minHeight: '140px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        '&:hover': {
                                            boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
                                            transform: 'translateY(-3px)',
                                            transition: 'all 0.3s'
                                        }
                                    }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white', textAlign: 'center' }}>
                                        <Typography sx={{ fontSize: '1.5rem', fontWeight: '800', lineHeight: 1.2, marginBottom: '8px' }}>
                                            {item.label}
                                        </Typography>
                                        <Typography sx={{ fontSize: '0.85rem', fontWeight: '400', opacity: 0.9 }}>
                                            {item.name}
                                        </Typography>
                                        {item.session && (
                                            <Typography sx={{ fontSize: '0.75rem', fontWeight: '600', marginTop: '8px', background: 'rgba(255,255,255,0.3)', padding: '4px 12px', borderRadius: '12px' }}>
                                                {item.session}
                                            </Typography>
                                        )}
                                        <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '35px', width: '35px', borderRadius: '30px', backgroundColor: 'rgba(255,255,255,0.3)' }}>
                                            <PlayArrowRounded sx={{ fontSize: '1.5rem' }} /> 
                                        </div>
                                    </Box>
                                </Card>
                            </Grid>
                            );
                        }) : isFatafatDollarLoading ? '' : 
                            <Grid item xs={12} sx={{textAlign: 'center', padding: '50px'}}>
                                <Typography>No game types available</Typography>
                            </Grid>
                        }
                    </Grid>
                </Container>
            }
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    isFatafatDollarLoading: state.fatafatdollar.isFatafatDollarLoading,
    fatafatDollarGameTypesData: state.fatafatdollar.fatafatDollarGameTypesData,
    isFatafatDollarDataFailed: state.fatafatdollar.isFatafatDollarDataFailed,
    fatafatDollarMsg: state.fatafatdollar.fatafatDollarMsg,
})

export default connect(mapStateToProps)(FatafatDollarGameList);

